import type { GuestQuoteLinkParams } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/** 주소가 형식에 맞지 않는 링크의 자리 입력 — enabled: false 라 보내지 않는다. */
const NO_LINK: GuestQuoteLinkParams = { quoteRequestId: '', signature: '' };

/**
 * 견적 링크 화면(quotes.getGuestView, 결정 G9) — 로그인 없이 서명 링크로 상태별 내용을 읽는다.
 * 링크 주소가 형식에 맞지 않으면(params null) 요청하지 않는다. 서명 불일치·없는 견적은 하나의 NOT_FOUND 이고, 다시 물어도 같아 재시도하지 않는다.
 */
export const useGuestQuoteViewQuery = (params: GuestQuoteLinkParams | null) =>
  trpc.quotes.getGuestView.useQuery(params ?? NO_LINK, {
    enabled: params !== null,
    retry: false,
  });
